export const STANDARD_INFORMATION = "STANDARD_INFORMATION";
export const WARNING_INFORMATION = "WARNING_INFORMATION";
export const SUCCESS_INFORMATION = "SUCCESS_INFORMATION";
